import { Profile } from '@designage/gql';

export interface IProfileState {
  loading?: boolean;
  activeProfile?: Profile;
}

export const initialProfileState: IProfileState = {};
